/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { QRCodeSVG } from 'qrcode.react';
const $ = require("jquery")
$.Datatable = require("datatables.net");
const SucWithdraw = () => {
    const [user, setUser] = useState()
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    
    let baseUrl;
    if (nodeMode === "development") {
        baseUrl = beckendLocalApiUrl;
    } else {
        baseUrl = beckendLiveApiUrl;
    }
    let [limit, setLimit] = useState(10);
    const setpageLimit = (event) => {
        let key = event.target.value
        setLimit(key);
    }
    const [pageNumber, setPageNumber] = useState(0);
    const [numberOfPages, setNumberOfPages] = useState(0);
    //user for searching..
    const [searchList, setSearchList] = useState(0);
    const [searchType, setSearchType] = useState(0);
    const [findByStatus, setFindByStatus] = useState(0);
    //react paginate..
    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        setPageNumber(currentPage);
    };
    //   searching handler
    const searchHandler = (event) => {
        let key = event.target.value
        setSearchList(key);
    }
    //   search by status handler
    const searchByStatus = (event) => {
        let key = event.target.value
        setFindByStatus(key);
    }
    const profle = () => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl + `txn/withdraw/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`, { headers })
            .then((res) => {
                setUser(res.data.data)
                setNumberOfPages(res.data.totalPages)
            })
    }
    const [selectedQR, setSelectedQR] = useState(null);
    
    const withdrowPass = (id) => {
        const confirm = window.confirm("Are you sure, you want to update to success this payout?")
        if (confirm) {
            const access_token = localStorage.getItem("token")
            const headers = {
                Authorization: `Bearer ${access_token}`
            }
            axios.post(baseUrl + `userwithdrawupdate/${id}`,
                {
                    status: "SUCCESS"
                },
                { headers })
                .then((res) => {
                    profle();
                    alert('Payout successfully done');
                }).catch((e) => {
                    //console.log(e);
                })
        }
    }
    const withdrowFail = (id) => {
        const confirm = window.confirm("Are you sure, you want to update to failed this payout?")
        if (confirm) {
            const access_token = localStorage.getItem("token")
            const headers = {
                Authorization: `Bearer ${access_token}`
            }
            axios.post(baseUrl + `userwithdrawupdate/${id}`,
                {
                    status: "FAILED"
                },
                { headers })
                .then((res) => {
                    profle();
                    alert('Payout successfully reject');
                }).catch((e) => {
                    //console.log(e);
                })
        }
    }
    const universalCheckPayout = (payment_gatway, txn_id, referenceId) => {
        if(!referenceId){
            alert('Payout txn id not found')
        }
        if (payment_gatway == 'razorpay') {
            checkrazorpaypayout(txn_id, referenceId)
        }
        else if (payment_gatway == 'decentro') {
            checkpayout(txn_id, referenceId)
        }
        else if (payment_gatway == 'pinelab') {
            //checkPinelabpayout(txn_id, referenceId)
        } else {
            checkHaodapayout(txn_id, referenceId)
            alert('Nothing found');
        }
    }
    const checkpayout = (txn_id, referenceId) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.post(baseUrl + `decentropayout/response`, { txn_id, referenceId }, { headers })
            .then((res) => {
                const icon = res.data.status == "SUCCESS" ? "success" : "danger";
                const title = res.data.status == "SUCCESS" ? "Withdraw successfully" : "Transaction Proccessing or Failed";
                profle();
                Swal.fire({
                    title: title,
                    icon: icon,
                    confirmButtonText: "OK",
                });
            })
            .catch((e) => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    window.location.reload()
                }
            })
    }
    const checkHaodapayout = (txn_id, referenceId) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.post(baseUrl + `withdraw/haoda/adminmanual`, { txn_id, referenceId }, { headers })
            .then((res) => {
                const icon = res.data.status == "SUCCESS" ? "success" : "danger";
                const title = res.data.status == "SUCCESS" ? "Withdraw successfully" : "Transaction Proccessing or Failed";
                profle();
                Swal.fire({
                    title: title,
                    icon: icon,
                    confirmButtonText: "OK",
                });
            })
            .catch((e) => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    window.location.reload()
                }
            })
    }
    
    const checkrazorpaypayout = (txn_id, referenceId) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.post(baseUrl + `razorpaypayoutscheck/response`, { txn_id, referenceId }, { headers })
            .then((res) => {
                const icon = res.data.status == "SUCCESS" ? "success" : "danger";
                const title = res.data.status == "SUCCESS" ? "Withdraw successfully" : "Transaction Proccessing or Failed";
                profle();
                Swal.fire({
                    title: title,
                    icon: icon,
                    confirmButtonText: "OK",
                });
            })
            .catch((e) => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    window.location.reload()
                }
            })
    }
    const dateFormat = (e) => {
        const date = new Date(e);
        const newDate = date.toLocaleString('default', { month: 'long', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
        return newDate;
    }
    let currentTime = Date.now();
    useEffect(() => {
        profle();
        // Auto-refresh every 8 seconds for real-time withdrawal status updates
        const interval = setInterval(() => {
            profle();
        }, 8000);
        return () => clearInterval(interval);
    }, [pageNumber, limit, searchList, searchType, findByStatus])
    if (user == undefined) {
        return null
    }
    // Styles
    const styles = `
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
        
        .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }
        
        .modern-card { background: #fff !important; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); overflow: hidden; margin-top: 20px; }
        .card-header-custom { background: linear-gradient(45deg, #57155a, #8e44ad); padding: 20px; }
        .card-title-custom { margin: 0; color: white !important; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
        /* Filters */
        .filters-container { padding: 20px; background: #fafafa; border-bottom: 1px solid #eee; display: flex; flex-wrap: wrap; gap: 15px; align-items: center; }
        .custom-select { padding: 8px 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 0.9rem; min-width: 140px; outline: none; background: white; color: #333; }
        .custom-input { padding: 8px 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 0.9rem; min-width: 200px; outline: none; color: #333; }
        /* Table */
        .table-responsive { overflow-x: auto; padding: 0 20px 20px 20px; }
        .custom-table { width: 100%; border-collapse: collapse; min-width: 1000px; }
        .custom-table thead th { background: #f8f9fa !important; color: #636e72 !important; font-weight: 700; text-transform: uppercase; font-size: 0.75rem; padding: 15px 15px; border-bottom: 2px solid #eee; text-align: left; }
        .custom-table tbody td { padding: 12px 15px; border-bottom: 1px solid #f1f1f1; vertical-align: middle; color: #2d3436 !important; font-size: 0.85rem; }
        .custom-table tbody tr:hover { background: #fafafa !important; }
        /* Badges & Buttons */
        .status-badge { padding: 4px 10px; border-radius: 4px; font-weight: 700; font-size: 0.7rem; text-transform: uppercase; display: inline-block; }
        .st-success { background: #e8f5e9; color: #2e7d32; }
        .st-pending { background: #fff3e0; color: #ef6c00; }
        .st-processing { background: #e3f2fd; color: #1565c0; }
        .st-failed { background: #ffebee; color: #c62828; }
        
        .btn-action { margin: 2px; padding: 5px 10px; border: none; border-radius: 5px; font-size: 0.75rem; font-weight: 600; cursor: pointer; transition: 0.2s; }
        .btn-green { background: #27ae60; color: white; }
        .btn-green:hover { background: #219150; }
        .btn-red { background: #c62828; color: white; }
        .btn-red:hover { background: #b71c1c; }
        .btn-danger-check { background: #c62828; color: white; padding: 5px 10px; border-radius: 4px; border: none; cursor:pointer; font-size: 0.75rem;}
        .user-link { color: #57155a; text-decoration: none; font-weight: 600; }
        .bank-details { background: #f9f9f9; padding: 8px; border-radius: 6px; border: 1px solid #eee; font-size: 0.8rem; margin-top: 5px; }
        /* Pagination */
        .pagination { display: flex; list-style: none; padding: 0; justify-content: center; gap: 5px; margin-top: 20px; flex-wrap: wrap; }
        .page-item { display: inline-block; }
        .page-link { padding: 8px 14px; border-radius: 8px; border: 1px solid #eee; color: #666 !important; cursor: pointer; text-decoration: none; font-size: 0.9rem; font-weight: 500; display: block; background: white; transition: 0.2s; }
        .page-link:hover { background: #f9f9f9; color: #57155a !important; border-color: #ddd; }
        .active .page-link { background: #57155a; color: white !important; border-color: #57155a; box-shadow: 0 4px 10px rgba(87, 21, 90, 0.3); }
    `;
    return (
        <div className="admin-mgmt-page">
            <style>{styles}</style>
            
            <div className="row">
                <div className="col-12">
                    <div className="modern-card">
                        
                        <div className="card-header-custom">
                            <h4 className="card-title-custom">Withdrawal History & Manual Requests</h4>
                        </div>
                        
                        <div className="filters-container">
                            <select className='custom-select' style={{width:'auto'}} onChange={setpageLimit}>
                                <option value="10">Set limit</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                            </select>
                            <select className='custom-select' onChange={(e) => setSearchType(e.target.value)}>
                                <option value="0">Select Search by</option>
                                <option value="Name">Name</option>
                                <option value="Phone">Phone</option>
                            </select>
                            
                            <input type='text' placeholder='Search...' className='custom-input' onChange={searchHandler} />
                            
                            <span>Or</span>
                            <select className='custom-select' onChange={searchByStatus}>
                                <option value="0">Search Status</option>
                                <option value="SUCCESS">Success</option>
                                <option value="Pending">Pending</option>
                                <option value="pending">pending</option>
                                <option value="none">Proccessing</option>
                                <option value="reject">Reject</option>
                                <option value="FAILED">Failed</option>
                            </select>
                        </div>
                        <div className="table-responsive">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>ID</th>
                                        <th>Phone</th>
                                        <th>User</th>
                                        <th>Type</th>
                                        <th>Account Details</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                        <th>Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user && user.map((data, key) => (
                                        <tr key={key}>
                                            <td style={{color:'#999', fontWeight:'bold'}}>{key + 1}</td>
                                            
                                            <td><div style={{fontFamily:'monospace', fontSize:'0.75rem', color:'#666'}}>{data._id.substring(0,8)}...</div></td>
                                            
                                            <td>{data.User_id ? data.User_id.Phone : '-'}</td>
                                            
                                            <td>
                                                {data.User_id && <Link className="user-link" to={`/user/view_user/${data.User_id._id}`} >{data.User_id.Name}</Link>}
                                            </td>
                                            
                                            <td><span style={{fontWeight:'500'}}>{data.Withdraw_type}</span></td>
                                            
                                            <td>
                                                {(data.Withdraw_type === 'UPI' || data.Withdraw_type === 'manualupi') &&
                                                <div>
                                                    <div style={{ marginTop: '5px', textAlign:'center' }}>
                                                        <div style={{ cursor: 'pointer', display:'inline-block' }} onClick={() => setSelectedQR(data)}>
                                                            <QRCodeSVG 
                                                                value={`upi://pay?pa=${data.User_id.upi_id}&pn=${data.User_id.holder_name}&am=${data.amount}&cu=INR&tn=Payment`} 
                                                                size={30}
                                                                level="H" 
                                                                includeMargin={true}
                                                            />
                                                            <div style={{fontSize:'0.65rem', color:'#57155a', fontWeight:'bold'}}>SCAN</div>
                                                        </div>
                                                    </div>
                                                    {data.Withdraw_type === 'upi' && 
                                                        <div style={{fontSize:'0.8rem'}}>UPI: <strong>{data.User_id.upi_id}</strong></div>
                                                    }
                                                </div>
                                                }
                                                
                                                {(data.Withdraw_type == 'banktransfer' || data.Withdraw_type === 'mypaybank') &&
                                                <div className="bank-details">
                                                    <div>Name: <strong>{data.User_id.holder_name}</strong></div>
                                                    <div>Acc: <strong>{data.User_id.account_number}</strong></div>
                                                    <div>IFSC: <strong>{data.User_id.ifsc_code}</strong></div>
                                                </div>
                                                }
                                            </td>
                                            <td style={{fontWeight:'700', color:'#27ae60'}}>₹{data.amount}</td>
                                            
                                            <td>
                                                <span className={`status-badge ${
                                                    (data.status === 'SUCCESS') ? 'st-success' : 
                                                    (data.status === 'FAILED' || data.status === 'reject') ? 'st-failed' : 
                                                    (data.status === 'none') ? 'st-processing' : 'st-pending'
                                                }`}>
                                                    {(data.status === "none") ? 'Proccessing' : data.status}
                                                </span>
                                            </td>
                                            
                                            <td>
                                                { // Check payout manually logic preserved
                                                   // data.Withdraw_type === 'mypaybank' && data.status != 'Pending' && (data.status != 'SUCCESS' && data.status != 'FAILED') ? 
                                                   // <button className="btn-danger-check" onClick={() => universalCheckPayout(data.payment_gatway, data._id, data.referenceId)} >Check {data.payment_gatway}</button> : '' 
                                                }
                                                {(data.Withdraw_type === 'UPI' || data.Withdraw_type === 'manualupi' || data.Withdraw_type == 'banktransfer') &&
                                                    (data.status != "SUCCESS" && data.status != "FAILED" && data.status!="reject") && (
                                                        <div style={{display:'flex', flexDirection:'column'}}>
                                                            <button className="btn-action btn-green" onClick={() => withdrowPass(data._id)}>Success</button>
                                                            <button className="btn-action btn-red" onClick={() => withdrowFail(data._id)}>Fail</button>
                                                        </div>
                                                )}
                                            </td>
                                            
                                            <td style={{fontSize:'0.8rem', color:'#888'}}>{dateFormat(data.createdAt).split(',')[0]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='p-3'>
                            <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={numberOfPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* QR Scanner Popup Modal */}
            {selectedQR && (
                <div 
                    style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center',
                    alignItems: 'center', zIndex: 9999, backdropFilter: 'blur(5px)'
                    }}
                    onClick={() => setSelectedQR(null)} 
                >
                    <div 
                        style={{ 
                            background: '#fff', padding: '25px', borderRadius: '16px', textAlign: 'center',
                            width: '320px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)', animation: 'fadeIn 0.3s ease'
                        }}
                        onClick={(e) => e.stopPropagation()} 
                    >
                        <h3 style={{ marginBottom: '15px', color: '#333', fontWeight:'bold' }}>Scan to Pay</h3>
                        
                        <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '12px', display: 'inline-block', border:'2px solid #57155a' }}>
                            <QRCodeSVG 
                                value={`upi://pay?pa=${selectedQR.User_id.upi_id}&pn=${selectedQR.User_id.holder_name}&am=${selectedQR.amount}&cu=INR&tn=Payment`} 
                                size={220} level="H" includeMargin={false}
                            />
                        </div>
                        <h2 style={{ margin: '15px 0 5px 0', color: '#27ae60', fontWeight:'800' }}>₹{selectedQR.amount}</h2>
                        
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f1f1f1', padding: '10px', borderRadius: '8px', marginTop: '10px' }}>
                            <span style={{ fontSize: '12px', fontWeight: '600', color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '200px' }}>
                                {selectedQR.User_id.upi_id}
                            </span>
                            <button 
                                onClick={(e) => {
                                    e.stopPropagation(); 
                                    navigator.clipboard.writeText(selectedQR.User_id.upi_id);
                                    Swal.fire({
                                        title: 'Copied!', text: selectedQR.User_id.upi_id,
                                        icon: 'success', timer: 1000, showConfirmButton: false, position: 'center'
                                    });
                                }}
                                style={{ padding: '5px 12px', backgroundColor: '#57155a', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }}
                            >
                            COPY
                            </button>
                        </div>
                        <button 
                            style={{ 
                                marginTop: '20px', width: '100%', padding: '12px', cursor: 'pointer',
                                backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '8px',
                                fontSize: '14px', fontWeight: 'bold', letterSpacing: '1px'
                            }}
                            onClick={() => setSelectedQR(null)}
                        >
                            CLOSE
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
export default SucWithdraw